module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/lines/wall/textures/painted.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/lines/wall/textures/painted.jpg
// module id = 467
// module chunks = 0